import React, { Suspense } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import Spinner from '../App/Components/Spinner/Spinner'
import { store } from '../store'

import { Menu } from './Menu'

export const MenuBootstrap = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<Spinner />}>
          <Menu />
        </Suspense>
      </BrowserRouter>
    </Provider>
  )
}
